import { render, staticRenderFns } from "./DragUpdateFiles.vue?vue&type=template&id=e4bd6426"
import script from "./DragUpdateFiles.vue?vue&type=script&lang=js"
export * from "./DragUpdateFiles.vue?vue&type=script&lang=js"
import style0 from "./DragUpdateFiles.vue?vue&type=style&index=0&id=e4bd6426&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports